// « Présente-toi en quelques mots » — shown ONCE on Home right after a publication when the
// member has no intro yet (server stamp users.bio_nudge_seen_at makes it never come back).
// Jamais pendant que la carte « Complète ton profil » est affichée (elle propose déjà la bio) — lot 589.
import { profileCompletionCardVisible } from "@/lib/profileDone";

const KEY = "yalola.bio_nudge_pending";

export const shouldNudgeBio = (user) =>
  !!user && !user.is_bot && !user.is_church && !(user.bio || "").trim() && !user.bio_nudge_seen_at && !profileCompletionCardVisible(user);

export const flagBioNudge = (user) => {
  if (!shouldNudgeBio(user)) return;
  try { sessionStorage.setItem(KEY, "1"); } catch { /* private mode */ }
  window.dispatchEvent(new Event("yalola:bio_nudge"));
};

export const bioNudgePending = () => {
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
};

export const clearBioNudge = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* noop */ }
};
